import { useRef, useState } from 'react';
import { useEffect } from 'react';
import { singletonHook } from 'react-singleton-hook';
import useFeatureFlagStore from 'src/stores/featureFlag/useFeatureFlagStore';
import { SwiftClient } from '@drift/common';
import { DriftWindow } from 'src/window/driftWindow';

const useSwiftServerHealthCheckImpl = () => {
	const isSignedMsgOrdersEnabled = useFeatureFlagStore((s) =>
		s.flagEnabled('ENABLE_SIGNED_MSG_ORDERS')
	);
	const currentTimeoutRef = useRef<null | ReturnType<typeof setTimeout>>(null);
	// Start off as undefined so we can determine when the data is still loading.
	// ^^ This doesn't seem to work, as the value is still somehow getting init'd
	// to `false`. This could be a good candidate for #reactquery.
	const [isHealthy, setIsHealthy] = useState<boolean>();

	useEffect(() => {
		const checkHealth = async () => {
			const isSwiftHealthy = await SwiftClient.isSwiftServerHealthy();
			setIsHealthy(isSwiftHealthy);
			if (!isSwiftHealthy) {
				DriftWindow.metricsBus.next({
					type: 'passthrough_metric',
					value: {
						swiftServerUnhealthy: 1,
					},
				});
				// when something is wrong with server, check more quickly to re-enable swift asap
				currentTimeoutRef.current && clearTimeout(currentTimeoutRef.current);
				currentTimeoutRef.current = setTimeout(checkHealth, 20_000);
			} else {
				// when server is healthy, check less frequently
				currentTimeoutRef.current && clearTimeout(currentTimeoutRef.current);
				currentTimeoutRef.current = setTimeout(checkHealth, 120_000);
			}
		};
		if (isSignedMsgOrdersEnabled) {
			checkHealth();
		}
	}, [isSignedMsgOrdersEnabled]);

	return isHealthy;
};

export const useSwiftServerHealthCheck = singletonHook(
	false,
	useSwiftServerHealthCheckImpl
);
